<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-5">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data rawat jalan</h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data pembayaran</h5>
              <FormRow
                v-for="row in paymentForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3 mt-3">data rujukan</h5>
              <FormRow
                v-for="row in referenceForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Rawat Jalan
                </button>
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/ralan')"
                  >Batalkan</a
                >
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  leftForm,
  paymentForm,
  today,
  time,
  referenceForm,
} from "@/data/RalanForm.js";
import { resetForms, setPatientIntro, validateForms } from "@/data/helper.js";
import { regexErrors, regexes, regexPlaceholders } from "@/data/helper.js";

export default {
  name: "RalanForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      validated: false,
      data: {
        title: "Ubah Data Rawat Jalan",
        backBtn: "/ralan/detail/",
        actionBtn: [],
        breadcrumb: [
          { title: "Detail Rawat Jalan", link: "/ralan/detail" },
          { title: "Ubah Data Rawat Jalan", active: true },
        ],
      },
      leftForm: leftForm,
      paymentForm: paymentForm,
      referenceForm: referenceForm,
      detailTop: null,
      formSet: {
        no_rm: "",
        no_rawat: "",
        id_unit: "",
        id_dokter: "",
        id_asuransi: "",
        no_reg: "",
        tgl_periksa: today,
        jam_periksa: time,
        darurat: 0,
        jen_periksa: "",
        no_peserta: "",
        dirujuk: "0",
        asal_rujukan: "",
        tindak_lanjut_pelayanan: "",
        merujuk: "0",
        tujuan_rujukan: "",
        status: "DIJADWALKAN",
      },
    };
  },
  methods: {
    goBack(url) {
      this.validated = false;
      resetForms(
        this.formSet,
        [this.leftForm, this.paymentForm, this.referenceForm],
        true,
        this.handleChange
      );
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      ////console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let body = "";
      // let valid = this.validateForm();
      const { forms, validity: valid } = validateForms(
        this.formSet,
        [this.leftForm, this.referenceForm, this.paymentForm],
        this,
        true
      );
      //console.log({forms,valid});
      this.validated = true;

      if (valid) {
        Object.keys(this.formSet).forEach(function(key, index) {
          ////console.log(key+': '+self.formSet[key]);
          if (key != "asuransi_lain" && key != "status") {
            formData.append(key, self.formSet[key]);
            body += `&${key}=${self.formSet[key]}`;
            ////console.log(formData.get(key));
          }
        });
        try {
          //console.log(body);
          let result = await this.$store.state.HTTP_ENC.put(
            "ralan/" + this.$route.params.id,
            body
          );
          ////console.log(result);
          if (result.status == "200") {
            this.validated = false;
            this.$router.push(`/ralan/detail/${this.$route.params.id}`);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    reset(url, stay) {
      resetForms(
        this.formSet,
        [this.leftForm, this.paymentForm, this.referenceForm],
        true,
        this.handleChange
      );
      if (!url) {
        this.$router.go(-1);
      } else {
        ////console.log(url);
        this.$router.push(url);
      }
    },
    handleChange(e, initial) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      if (e.target.name == "id_asuransi") {
        if (e.target.value == 1) {
          // Hide kolom Pilih Asuransi
          this.paymentForm[1].columns[0].type = "hidden";
          // Hide Kolom Nomor Peserta
          this.paymentForm[2].columns[0].type = "hidden";
          // Reset Regex pada Kolom Nomor Peserta
          this.paymentForm[2].columns[0].regex = "";
          this.paymentForm[2].columns[0].placeholder = "";
          this.paymentForm[2].columns[0].regexError = "";
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
        }
        // Jika yang dipilih adalah Metode Pembayaran BPJS
        else if (e.target.value == 2) {
          // Hide kolom Pilih Asuransi
          this.paymentForm[1].columns[0].type = "hidden";
          // Show kolom Nomor Peserta
          this.paymentForm[2].columns[0].type = "text";
          this.paymentForm[2].columns[0].mandatory = true;
          this.paymentForm[2].columns[0].optional = false;
          // Set Regex pada Kolom Nomor Peserta
          this.paymentForm[2].columns[0].regex = regexes.BPJS;
          this.paymentForm[2].columns[0].placeholder = regexPlaceholders.BPJS;
          this.paymentForm[2].columns[0].regexError = regexErrors.BPJS;
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
        }
        // Jika yang dipilih adalah Metode Pembayaran Asuransi Lain
        else if (e.target.value == 3) {
          // Show kolom Pilih Asuransi
          this.paymentForm[1].columns[0].type = "select";
          // Show kolom nomor peserta
          this.paymentForm[2].columns[0].type = "text";
          this.paymentForm[2].columns[0].mandatory = false;
          this.paymentForm[2].columns[0].optional = true;
          // Reset Regex pada Kolom Nomor Peserta
          this.paymentForm[2].columns[0].regex = "";
          this.paymentForm[2].columns[0].placeholder = "";
          this.paymentForm[2].columns[0].regexError = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
        }
        if (this.validated) {
          // this.validateForm();
          const { forms, validity: valid } = validateForms(
            this.formSet,
            [this.leftForm, this.referenceForm, this.paymentForm],
            this,
            true
          );
          //console.log({forms,valid});
          this.validated = true;
        }
      } else if (e.target.name == "id_unit") {
        this.fetchDoctors();
      } else if (e.target.name == "dirujuk") {
        this.referenceForm[1].columns[0].type =
          e.target.value == "1" ? "select" : "hidden";
        if (e.target.value == "1") {
          this.referenceForm[1].columns[0].value = "";
        }
      } else if (e.target.name == "tindak_lanjut_pelayanan") {
        this.referenceForm[3].columns[0].type =
          e.target.value == "Dirujuk" ? "select" : "hidden";
        this.formSet.merujuk = e.target.value == "Dirujuk" ? "1" : "0";
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);

      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          ////console.log({'column.name':self.formSet[column.name]});
          return column;
        });
        return row;
      });

      this.referenceForm = this.referenceForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.paymentForm = this.paymentForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.validated = true;
      return valid;
    },
    displayIntro: async function(no_rm) {
      try {
        let result = await this.$store.state.HTTP.get(`pasien/cari/${no_rm}`);
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let patient = result.data;
          if (patient.asuransi_lain) {
            let resultAsuransi = await this.$store.state.HTTP.get(
              `asuransi_lain/${patient.asuransi_lain}`
            );
            if (resultAsuransi && resultAsuransi.status == "200") {
              patient.asuransi.nama += `: ${resultAsuransi?.data?.nama}`;
            }
          }
          this.detailTop = setPatientIntro(patient);
          this.formSet["id_asuransi"] = String(patient.asuransi.id);
          this.formSet["asuransi_lain"] = String(patient.asuransi_lain);
          this.formSet["no_peserta"] = String(patient.no_peserta || "");
          this.paymentForm[0].columns[0].value = String(patient.asuransi.id);
          this.paymentForm[1].columns[0].value = String(patient.asuransi_lain);
          this.paymentForm[1].columns[0].type =
            patient.asuransi.id == "3" ? "select" : "hidden";
          this.paymentForm[2].columns[0].value = String(
            patient.no_peserta || ""
          );
          this.paymentForm[2].columns[0].type =
            patient.asuransi.id == "1" ? "hidden" : "text";
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let doctors = result.data.data;
          ////console.log(doctors);
          this.leftForm[4].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchUnits: async function() {
      try {
        let result = await this.$store.state.HTTP.get("unit");
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let units = result.data.data;
          this.leftForm[3].columns[0].options = units.map(function(item) {
            item.label = `${item.kode_unit} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          ////console.log(units);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchFaskes: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      if (this["created_at"]) {
        params += `&created_at=${this.created_at}`;
      }
      if (this["id_faskes"]) {
        params += `&id_faskes=${this.id_faskes}`;
      }
      try {
        let result = await this.$store.state.HTTP.get("faskes" + params);
        ////console.log(result);
        if (result.status == "200") {
          ////console.log("berhasil");
          let faskes = result.data.data;
          this.referenceForm[1].columns[0].options = faskes.map(function(item) {
            ////console.log(item);
            item.label = `${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          ////console.log(this.rows);
        } else {
          ////console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    fetchAsuransi: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "asuransi_lain?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let items = result.data.data;
          ////console.log(items);
          this.paymentForm[1].columns[0].options = items.map(function(item) {
            item.label = `${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    generateNoRawat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `/ralan/generate/no_rawat`
        );
        if (result.status == "200") {
          ////console.log(result);
          let no_rawat = result.data.baru;
          this.formSet.no_reg = no_rawat.split("/")[3];
          this.formSet.no_rawat = no_rawat;
          ////console.log(this.formSet.no_reg);
          ////console.log(this.formSet.no_rawat);
          this.leftForm[0].columns[0].value = this.formSet.no_reg;
          this.leftForm[0].columns[1].value = this.formSet.no_rawat;
          ////console.log(this.leftForm[0].columns[0].value);
          ////console.log(this.leftForm[0].columns[1].value);
          this.leftForm.splice(0, 1, this.leftForm[0]);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}?darurat=0`
        );
        ////console.log(result);
        if (result.status == "200") {
          let ralan = result.data;
          this.displayIntro(ralan.pasien.no_rm);

          ////console.log(ralan);
          // this.formSet=pasien;
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            self.formSet[key] = ralan[key];
          });
          ////console.log(self.formSet);

          this.updateForm();
          ////console.log(ralan);
        } else {
          ////console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.leftForm, this.paymentForm, this.referenceForm].map(
        function(form) {
          form = form.map(function(row) {
            row.columns = row.columns.map(function(column) {
              if (String(self.formSet[column.name])) {
                column.value = self.formSet[column.name];
                if (
                  // column.name == "dirujuk" ||
                  // column.name == "tindak_lanjut_pelayanan" ||
                  column.name == "id_unit" ||
                  column.name == "id_dokter"
                  // column.name == "jen_periksa"
                ) {
                  self.handleChange({
                    target: {
                      value: column.value,
                      type: column.type,
                      name: column.name,
                    },
                  });
                } else if (
                  [
                    "id_asuransi",
                    "no_peserta",
                    "dirujuk",
                    "tindak_lanjut_pelayanan",
                    "jen_periksa",
                  ].indexOf(column.name) > -1
                ) {
                  console.log(column.name);
                  self.handleChange(
                    {
                      target: {
                        value: String(self.formSet[column.name]),
                        name: column.name,
                        type: column.type,
                      },
                    },
                    true
                  );
                }
              }
              return column;
            });
            return row;
          });
          return form;
        }
      );
      this.leftForm = forms[0];
      this.paymentForm = forms[1];
      this.referenceForm = forms[2];
      this.leftForm.splice(2, 1, this.leftForm[2]);
      this.leftForm.splice(3, 1, this.leftForm[3]);
      this.leftForm.splice(4, 1, this.leftForm[4]);
      this.paymentForm.splice(1, 1, this.paymentForm[1]);
      this.referenceForm.splice(1, 1, this.referenceForm[1]);
      //   this.fetchDoctors();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = "/ralan/detail/" + this.$route.params.id;
    this.data.breadcrumb[0].link = "/ralan/detail/" + this.$route.params.id;
    // this.data.toReset = this.reset;
    this.formSet["no_rm"] = this.$route.params.no_rm;
    // this.generateNoRawat();
    this.fetchUnits();
    this.fetchFaskes();
    this.fetchAsuransi();
    this.fetchDoctors();
    this.displayData();
    // this.referenceForm.splice(1, 1, this.referenceForm[1]);
  },
};
</script>
